import HootsuiteContentSourceCallbackPage from './callbackPage'
import Login from './login'
import Logout from './logout'
import AuthenticationError from './authenticationError'

export default {
  name: 'HootsuiteContentSourceAuth',
  routeProps: {
    path: '/authentication',
  },
  children: [HootsuiteContentSourceCallbackPage, Login, Logout, AuthenticationError],
}
